export default __webpack_public_path__ + "static/media/au_civm.dbd016b2.jpg";